<div class='amap-info-window-inner'></div>
<div class='amap-info-window-content'>
    <ng-content></ng-content>
</div>